// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import { gql } from 'graphql-tag';
export const ComponentWarrantyActivationFormFragmentDoc = gql`
    fragment componentWarrantyActivationForm on ComponentWarrantyActivationForm {
  __typename
}
    `;